import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-sand">
        <div className="w-3 h-3 rounded-full bg-moss animate-breathe"></div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}
